import { Outlet, Link } from "react-router-dom";
import '../styles/defaultPage.css'

const DefaultPage = () => {
    return (
        <html>
            <body>
                <div class="container" style={{ flex: 1, height: "100vh", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                    <h1 >Welcome To Policies</h1>
                    <Link to="oneDayToDoPrivacyPolicy">one day to do</Link>
                    <Link to="pomodoroPrivacyPolicy">pomodoro</Link>
                </div>
            </body>

        </html>

    );

}

export default DefaultPage;